import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Auto-select value in number inputs on focus for easier editing
document.addEventListener('focusin', e => {
  const target = e.target as HTMLInputElement;
  if (target.tagName === 'INPUT' && target.type === 'number') {
    target.select();
  }
});
render(<App data-id="element-356" />, document.getElementById('root'));